import React from 'react';
import { useSelector } from 'react-redux';
import { Redirect } from 'react-router-dom';

import { isUserFree } from 'helpers/userHelper';
import { Subscription } from 'types/subscription';
import { User } from 'types/user';

import { LoadingAnimation } from 'components/common';

type Props = {
  children: JSX.Element;
};

function EnsureSubTosAccepted({ children }: Props) {
  const user = useSelector<any, User>((store) => store.rootReducer.user);

  // If user ain't loaded yet, show loading animation
  if (!user) {
    return <LoadingAnimation />;
  }

  const userNeedToAcceptTos = () => {
    if (!user || !user.subscription) {
      return false;
    }
    const { status } = user.subscription as Subscription;

    if (isUserFree(user)) {
      return false;
    }
    if (status !== 'temporal') {
      return false;
    }

    return true;
  };

  // If user has a subscription that needs to accept TOS, redirect to TOS acceptance page
  if (user && user.subscription && userNeedToAcceptTos()) {
    return <Redirect to="/sub_tos" />;
  }

  return <>{children}</>;
}

export default EnsureSubTosAccepted;
